var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2070_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51336 9.67282L11.5446 4.23278C12.1073 3.79741 12.8927 3.79741 13.4554 4.23278L20.4866 9.67282C20.8695 9.96908 21.0938 10.4262 21.0938 10.9108V19.5293C21.0938 20.3933 20.3942 21.0938 19.5312 21.0938H16.3438C15.5153 21.0938 14.8438 20.4222 14.8438 19.5938V17.1826C14.8438 15.8866 13.7944 14.8359 12.5 14.8359C11.2056 14.8359 10.1562 15.8866 10.1562 17.1826V19.5938C10.1562 20.4222 9.48468 21.0938 8.65625 21.0938H5.46875C4.60581 21.0938 3.90625 20.3933 3.90625 19.5293V10.9108C3.90625 10.4262 4.13046 9.96908 4.51336 9.67282Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2070_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.849a5e74c188ffc996c5261b9239eda3.svg";
export { ForwardRef as ReactComponent };